export default "__VITE_PUBLIC_ASSET__bf2d096a__"